import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { blog_helper } from "@/helpers/blog_helper";

export default function BlogsPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      meta: { title: createTitle("Blog") },
      content: [
        { component: "BreadcrumbNavigation", props: { items: [{ label: "Blog", href: getRoute("blog") }] } },
        {
          component: "Header",
          props: {
            title: { path: "page.blogs.component.Header.title", placeholder: "Global Medics Blog" },
            description: { path: "page.blogs.component.Header.description" },
          },
        },
        {
          component: "ArticleFeed",
          props: {
            items: blog_helper.fetch().map((i) => ({
              ...i,
              image: i.card_image ?? i.image ?? null,
            })),
            showCategoryFilter: true,
            showTagFilter: true,
            showSearchField: true,
          },
        },
      ],
    },
  };
}
